<template>
  <div id="dash_header" :style="{backgroundColor: bg_color}">
    <!-- ROW 1 -->
    <!-- Page Title -->
    <div id="header_title" class="header_row_1 uppercase">&nbsp;&nbsp;&nbsp;Election 2020</div>
    <!-- Logo -->
    <div id="top_logo" class="header_row_1">
      <router-link to="/">
        <img
          src="/img/Daily-Snaphot-Logo-Red-310x50.svg"
          alt="Daily-Snapshot.com Logo"
          title="About Daily-Snapshot.com"
          width="100%"
          height="100%"
        />
      </router-link>
    </div>
    <!-- About Icon (hamburger) -->
    <div id="header_menu_icon" class="header_row_1">
      <router-link to="/about">
        <svg viewBox="0 0 100 80" width="60%" height="60%">
          <rect width="100" height="20" fill="white" rx="8" />
          <rect y="30" width="100" height="20" fill="white" rx="8" />
          <rect y="60" width="100" height="20" fill="white" rx="8" />
        </svg>
      </router-link>
    </div>
    <!-- ROW 2 -->
    <!--  Date -->
    <div class="header_row_2" id="header_date">
      <span>{{todays_date}}</span>
    </div>
    <!-- Tagline -->
    <div class="header_row_2 uppercase" id="header_tagline">
      What the
      <b>polls</b> and the
      <b>betting markets</b> are saying today
    </div>
    <!-- copyright -->
    <div class="header_row_2 uppercase" id="header_copyright">&copy; Stephen Voltz 2020</div>
  </div>
</template>

<script>
const DATE_FORMAT_OPTS = {
  // weekday: "short",
  year: "numeric",
  month: "long",
  day: "numeric"
};
const DATE_FORMAT_SHORT_OPTS = {
  year: "numeric",
  month: "long",
  day: "numeric"
};
let now = new Date();
let display_date = (this.date = now.toLocaleString("en-US", DATE_FORMAT_OPTS));
let display_date_short = (this.date = now.toLocaleString(
  "en-US",
  DATE_FORMAT_SHORT_OPTS
));

module.exports = {
  name: "DashHeader",
  props: {
    header_title: String,
    bg_color: { type: String, default: "#435f8e" }
  },
  mounted() {
    this.update_date();
  },
  data: function() {
    return {
      greeting: "hello",
      todays_date: display_date,
      todays_date_short: display_date_short
    };
  },
  methods: {
    update_date() {
      let now = new Date();
      //break at 140w;
      this.todays_date = now.toLocaleString("en-US", DATE_FORMAT_OPTS);
      this.todays_date_short = now.toLocaleString(
        "en-US",
        DATE_FORMAT_SHORT_OPTS
      );
    }
  }
};
</script>
<style >
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

#top_logo {
  width: max(min(300px, 50vw), 200px);
  justify-self: center;
  align-items: center;
  margin-top: 0.5rem;
}
#dash_header {
  position: relative;
  display: grid;
  justify-content: stretch;
  grid-template-rows: 65px 30px;
  grid-template-columns: auto 2fr auto;
  grid-gap: 0px;
  width: 100%;
  height: 95px;
}

.header_row_1 {
  background-color: #435f8e;
  height: 10.5vmax;
  max-height: 65px;
  justify-self: center;
  font-size: max(min(0.5vw, 0.5em), 1rem);
}
.header_row_2 {
  background-color: #6582b2;
  font-size: max(min(0.5vw, 0.5em), 0.65rem);
  max-height: 30px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
#dash_header {
  font-family: "Montserrat", sans-serif;
  border: 1px solid gray;
  width: 100%;
  background-color: #435f8e;
  color: white;
}
</style>
<style scoped>
.uppercase {
  text-transform: uppercase;
}
/* TODO: use grid or flex for this rather than absolute? */

#header_menu_icon {
  padding: 5px;
}
#header_menu_icon:hover {
  background-color: #6582b2;
}

#header_menu_icon {
  display: grid;
  align-items: center;
  justify-self: end;
  grid-template-columns: 1fr;
  justify-content: right;

  min-width: 40px;
  max-width: 70px;
}
#header_title {
  display: flex;
  padding-left: 1rem;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 770px) {
  .header_row_1 {
    max-height: 30px;
  }
  .header_row_2 {
    max-height: 60px;
    height: 100%;
  }
  #dash_header {
    grid-template-rows: 50px 45px;
  }
}
#header_date > span {
  justify-self: start;
  text-align: left;
}
</style>